var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"gradient-button",style:(_vm.customStyles),attrs:{"disabled":_vm.disabled},on:{"click":_vm.emitClick}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }